import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Error from "../../Images/404.svg";
import { APP_ROUTES } from "../../globals/constants";

import "./datanotfound.scss";

const DataNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="data_not_found">
      <img src={Error} />
    </div>
  );
};

export default DataNotFound;
